'use client'

import { memo } from 'react'

import { useWordHuntContext } from '../context'

import { Board } from './Board'
import { Words } from './Words'

/**
 * Props do componente GameArea
 */
interface GameAreaProps {
  showWords?: boolean
}

/**
 * Componente GameArea que coordena o jogo
 * Segue princípios de Clean Code: componente focado, memoizado
 */
export const GameArea = memo<GameAreaProps>(({ showWords = false }) => {
  const {
    foundWords,
    gameBoard,
    foundLetterPositions,
    selectedPositions,
    selectionError,
    selectionSuccess,
    handleSquareClick,
    handleSquareEnter,
    handleSelectionEnd
  } = useWordHuntContext()

  const activePositions = selectedPositions
  const foundPositions = foundLetterPositions

  return (
    <div className="flex min-h-0 w-full max-w-lg flex-col gap-3 overscroll-contain supports-[padding:max(0px)]:pb-[max(0.35rem,env(safe-area-inset-bottom))] sm:gap-4">
      <Board
        board={gameBoard.board}
        activePositions={activePositions}
        foundPositions={foundPositions}
        onSquareClick={handleSquareClick}
        onSquareEnter={handleSquareEnter}
        onSelectionEnd={handleSelectionEnd}
        selectionError={selectionError}
        selectionSuccess={selectionSuccess}
      />

      <Words
        words={gameBoard.words}
        foundWords={foundWords}
        showWords={showWords}
      />
    </div>
  )
})

GameArea.displayName = 'GameArea'
